import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import Blog_solar_And_hybrid_energy from "../../Assets/Blog_solar_And_hybrid_energy.webp";
import Windmills_powering_tomorrow from "../../Assets/Windmills_powering_tomorrow.webp";
//import Future_Innovations_blog_img from "../../Assets/Future Innovations blog img.webp";
import "./blog.css";

function Blog() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      mirror: true,
      once: false,
      offset: 120,
    });
    AOS.refresh();
  }, []);
  return (
    <Container fluid>
      {/* Header Row */}
      <Row className="headingimg">
        <Col className="m-5">
          <h2 className="text-white m-4 mx-4 px-2 fw-bold text-center">
            Blogs
          </h2>
          <div className="text-white m-4 fw-bold text-center">
            <a href="/" className="text-white m-3 text-decoration-none">
              Home
            </a>
            <i className="fa-solid fa-circle-arrow-right"></i>
            <a href="#" className="text-white text-decoration-none m-3">
              Blogs
            </a>
          </div>
        </Col>
      </Row>

      <Row className="p-3 bg-dark">
        {/* <Col md={4} className="mb-4">
          <div className="card h-100">
            <img
              src={Future_Innovations_blog_img}
              className="card-img-top img-fluid p-3 rounded zoom-img"
              alt="Hydroponic innovation"
              style={{ height: "350px" }}
            />
            <div className="card-body">
              <h2 className="card-title text-decoration-underline">
                Future Innovations: What’s Next in Hydroponics — Aeroponics,
                Container Farms & Vertical Modules
              </h2>
              <div className="text-muted d-flex align-items-center mt-3">
                <i className="fa fa-calendar me-2"></i>
                <span>November 11, 2025</span>
              </div>
            </div>
            <div className="card-footer text-center">
              <Link
                to="/Future-innovation-in-hydroponics"
                className="btn btn-success"
              >
                View More
              </Link>
            </div>
          </div>
        </Col>*/}
        <Col md={4} className="mb-4">
          <div className="card h-100">
            <img
              src={Windmills_powering_tomorrow}
              className="card-img-top img-fluid p-3 rounded zoom-img"
              alt="Windmill Energy"
              style={{ height: "350px" }}
            />
            <div className="card-body">
              <h2 className="card-title text-decoration-underline">
                Windmills Powering Tomorrow
              </h2>
              <div className="text-muted d-flex align-items-center mt-3">
                <i className="fa fa-calendar me-2"></i>
                <span>May 14, 2026</span>
              </div>
            </div>
            <div className="card-footer text-center">
              <Link to="/Windmills_Powering_Tomorrow">View More</Link>
            </div>
          </div>
        </Col>
        <Col md={4} className="mb-4">
          <div className="card h-100">
            <img
              src={Blog_solar_And_hybrid_energy}
              className="card-img-top img-fluid p-3 rounded zoom-img"
              alt="Hybrid energy"
              style={{ height: "350px" }}
            />
            <div className="card-body">
              <h2 className="card-title text-decoration-underline">
                The Future of Power: How Solar & Hybrid Energy Systems Are
                Transforming Electrical Infrastructure
              </h2>
              <div className="text-muted d-flex align-items-center mt-3">
                <i className="fa fa-calendar me-2"></i>
                <span>May 04, 2026</span>
              </div>
            </div>
            <div className="card-footer text-center">
              <Link to="/Future_of_Power_Solar_and_Hybrid_Energy">
                View More
              </Link>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
}
export default Blog;
